import makePlural from "../makePlural";
import makeSingular from "../makeSingular";

export default function getReduxTypesImports(params) {
  let reduxReducersImports = [];

  if (params?.features === "rw" || params?.features === "r") {
    reduxReducersImports = [...reduxReducersImports, ...getReduxReadTypesImports(params.module)];
  }

  if (params?.features === "rw" || params?.features === "w") {
    reduxReducersImports = [...reduxReducersImports, ...getReduxWriteTypesImports(params.module)];
  }

  return reduxReducersImports;
}

function getReduxReadTypesImports(module) {
  const pruralModuleName = makePlural(module).toUpperCase();
  const singularModuleName = makeSingular(module).toUpperCase();

  return [
    // Types for all/list of data
    "FETCH_All_" + pruralModuleName + "_REQUEST",
    "FETCH_All_" + pruralModuleName + "_SUCCESS",
    "FETCH_All_" + pruralModuleName + "_FAILURE",
    // Types for single data
    "FETCH_SINGLE_" + singularModuleName + "_REQUEST",
    "FETCH_SINGLE_" + singularModuleName + "_SUCCESS",
    "FETCH_SINGLE_" + singularModuleName + "_FAILURE",
  ];
}

function getReduxWriteTypesImports(module) {
  const singularModuleName = makeSingular(module).toUpperCase();

  return [
    // Types for create data
    "CREATE_" + singularModuleName + "_REQUEST",
    "CREATE_" + singularModuleName + "_SUCCESS",
    "CREATE_" + singularModuleName + "_FAILURE",
    // Types for update data
    "UPDATE_" + singularModuleName + "_REQUEST",
    "UPDATE_" + singularModuleName + "_SUCCESS",
    "UPDATE_" + singularModuleName + "_FAILURE",
    // Types for delete data
    "DELETE_" + singularModuleName + "_REQUEST",
    "DELETE_" + singularModuleName + "_SUCCESS",
    "DELETE_" + singularModuleName + "_FAILURE",
  ];
}
